import { render, staticRenderFns } from "./NationalIndex.vue?vue&type=template&id=64b4e746&scoped=true"
import script from "./NationalIndex.vue?vue&type=script&lang=js"
export * from "./NationalIndex.vue?vue&type=script&lang=js"
import style0 from "./NationalIndex.vue?vue&type=style&index=0&id=64b4e746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4e746",
  null
  
)

export default component.exports